import { ReactComponent as EmailIcon } from "../../static/images/email.svg";

import "./style.scss";

const SendEmailButton = ({ email }) => {
  return (
    <a className="send-email" href={`mailto:${email}`}>
      <div className="email-icon">
        <EmailIcon />
      </div>
      {email}
    </a>
  );
};

export default SendEmailButton;
